<template>
    <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
</template>

<script>
    import FormBuilder from "../../FormBuilder.vue"

    export default {
        components: {
            FormBuilder
        },
        props: {
            formValue: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            formData: [
                {
                    title: "Packing Constraints",
                    description: "Define which DUNs that are allowed to be packed into the same shipper",
                    anchor: "6.1",
                    forms: [{
                        type: "sectionarray",
                        label: "Name",
                        value: "shipping.packing.constraints",
                        buttonText: "New packing constraint",
                        grid: "grid-50w",
                        forms: [{
                            type: "guid",
                            value: "id"
                        }, {
                            type: "text",
                            label: "Name of packing constraint",
                            value: "name",
                            required: true
                        }, {
                            type: "buttonlist",
                            label: " ",
                            value: "noConstraints",
                            preValues: [{
                                label: "Add DUNs",
                                globalValue: "dispensingUnits",
                                callback: function (formValue, global) {
                                    formValue.dispensingUnits = [];
                                    global.forEach((dun) => {
                                        formValue.dispensingUnits.push({
                                            id: dun.id,
                                            name: dun.name
                                        });
                                    });
                                }
                            }, {
                                label: "Remove DUNs",
                                globalValue: "dispensingUnits",
                                callback: function (formValue, global) {
                                    formValue.dispensingUnits = [];
                                }
                            }]
                        }, {
                            type: "sectionarray",
                            label: "Dispensing Units",
                            value: "dispensingUnits",
                            buttonText: "Associate Dispensing Unit",
                            extraClass: "grid-full",
                            forms: [{
                                type: "select",
                                label: "Dispensing Unit name",
                                value: "id",
                                required: true,
                                preValues: {
                                    field: "dispensingUnits",
                                    value: "id",
                                    name: "name"
                                }
                            }]
                        }]
                    }]
                }, {
                    title: "Shipper Types",
                    description: "Define properties for each shipper type",
                    anchor: "6.2",
                    forms: [{
                        type: "sectionarray",
                        label: "Shipper types",
                        value: "shipperTypes",
                        buttonText: "New shipper type",
                        grid: "grid-50w",
                        forms: [{
                            type: "guid",
                            value: "id"
                        }, {
                            type: "text",
                            label: "Name",
                            required: true,
                            value: "name"
                        }, {
                            type: "number",
                            label: "Default cost",
                            value: "defaultCost",
                            required: true,
                            inline: "{currency}"
                        }, {
                            type: "number",
                            label: "Capacity",
                            value: "capacity",
                            required: true
                        }, {
                            type: "checkboxlist",
                            label: "Allow shipment for",
                            value: "allowFor",
                            preValues: [{
                                label: "Depots",
                                value: "depots",
                            }, {
                                label: "Sites",
                                value: "sites",
                            }]
                        }, {
                            type: "select",
                            label: "Packing constraint",
                            value: "constraint",
                            required: true,
                            preValues: {
                                field: "shipping.packing.constraints",
                                value: "id",
                                name: "name"
                            }
                        }]
                    }]
                }, {
                    title: "Review Shipper Setup",
                    description: "Adjust default costs and remove not applicable routes",
                    anchor: "6.3",
                    forms: [{
                        type: "sectiontable",
                        value: "shipperReview",
                        extraClass: "shipperReview",
                        searchPlaceholder: "Search chain",
                        forms: [{
                            type: "checkbox",
                            name: "Default",
                            value: "isDefault",
                            helper: "Mark if the route has same cost as default cost"
                        }, {
                            type: "label",
                            name: "Shipping Depot",
                            value: "depotName"
                        }, {
                            type: "label",
                            name: "Receiving site/depot",
                            value: "receivingName"
                        }, {
                            type: "label",
                            name: "Properties",
                            value: "properties"
                        }, {
                            type: "number",
                            name: "Cost",
                            value: "cost",
                            inline: "{currency}"
                        }, {
                            type: "button",
                            name: "Status",
                            value: "",
                            helper: "Mark if the shipper type is not available for the route"
                        }, {
                            type: "hidden",
                            name: "isHidden",
                            value: "isHidden"
                        }]
                    }]
                }]
        }),
        mounted() {
            // Trigger an update of review when page is loaded
            if (this.formValue.shipperTypes)
                this.updateShipperReviews(this.formValue);
        },
        watch: {
            "formValue.shipperTypes": {
                handler: function () {
                    this.updateShipperReviews(this.formValue);
                },
                deep: true
            },
            "formValue.shipping.packing.constraints": {
                handler: function () {
                    this.updateShipperReviews(this.formValue);
                },
                deep: true
            }
        }
    }
</script>
